import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/permission-sector')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/permission/GetPermissionSectorList.js